export const formatDate = (dateString) => {
    let date = new Date(dateString);

    let Y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();

    let H = date.getHours();
    let i = date.getMinutes();
    let s = date.getSeconds();

    return `${Y}-${m < 10 ? "0" : ""}${m}-${d < 10 ? "0" : ""}${d} ${H < 10 ? "0" : ""}${H}:${i < 10 ? "0" : ""}${i}:${s < 10 ? "0" : ""}${s}`;
}